export enum TicketUpdateSource {
  Solver = "Solver",
  WebApi = "WebApi",
  Action = "Action"
}
